import React from "react";
import Page from "../../components/page/Page";
import PageHeader from "../../features/page-header/PageHeader";
import { Space } from "../../components/space/Space";
import { TableComponent } from "../../components/table/TableComponent";
import { useLocation, useParams } from "react-router-dom";
import { useTable } from "../../components/table/hooks";
import { tableMapping } from "../../components/table/definitions";
import { useAppSelector } from "../../app/store/hooks";
import { StatusEnum } from "../../endpoints/getArtifacts";
import Box from "@amzn/meridian/box";

export const Property: React.FC = () => {
    const { pathname } = useLocation();
    const { currentTable } = useTable();
    const { documentType } = useParams();
    const title = tableMapping[pathname.split("/")[1]].label;
    const { alias } = useAppSelector(state => state.auth.user);

    return (
        <Page
            type="form"
            title={title}
            description={undefined}
            hasBreadcrumbs={true}
            actions={null}
            currentTable={pathname.split("/")[1]}
        >
            <Space size={"xs"} />
            <PageHeader />
            <Space size={"s"} />
            <Box
                type={"fill"}
                overflowY={"hidden"}
                backgroundColor={"principal"}
                spacingInset={"400"}
            >
                <TableComponent
                    onSearch={false}
                    tableQueryParams={{
                        ...(tableMapping[currentTable]?.status && {
                            status: tableMapping[currentTable]?.status,
                        }),
                        ...((tableMapping[currentTable]?.assignedTo ||
                            documentType === StatusEnum.OVERDUE) && {
                            assignedTo: alias,
                        }),
                        ...(documentType && {
                            documentType: documentType,
                        }),
                        ...(tableMapping[currentTable]?.artifactType && {
                            artifactType: tableMapping[currentTable]?.artifactType,
                        }),
                        ...(tableMapping[currentTable]?.documentType && {
                            documentType: tableMapping[currentTable]?.documentType,
                        }),
                        ...(tableMapping[currentTable]?.propertyType && {
                            associatedPropertyType: tableMapping[currentTable]?.propertyType,
                        }),
                    }}
                    data={[]}
                />
            </Box>
        </Page>
    );
};
